import React, { useState } from 'react';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import {
  useGetRequestToPublishForm,
  useSubmitRequestToPublishForm
} from '../../hooks';
import Redirect from '../../../components/util/Redirect/Redirect';
import Loader from '../../../common/components/layout/Loader';
import { Theme } from 'theme/survey-js/theme';
import Header from 'legacy/common/components/wysiwyg-form/Header';
import { useEventEditorContext } from '../../contexts/EventEditorContext';

import 'survey-core/defaultV2.min.css';

const RequestToPublishForm: React.FC = () => {
  const {
    requestToPublishFormId,
    requestPublication,
    isDraft,
    isEditing,
    isLoading: headerIsLoading,
    lastUpdated,
    handleBack,
    navigateToEventSettings
  } = useEventEditorContext();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data, isLoading, isError } = useGetRequestToPublishForm(
    requestToPublishFormId
  );

  const submitForm = useSubmitRequestToPublishForm();

  const onSubmit = ({ data }) => {
    setIsSubmitting(true);
    submitForm.mutate(
      {
        formId: requestToPublishFormId,
        body: data
      },
      {
        onSuccess: (res) => {
          requestPublication({ responseId: res.id });
        }
      }
    );
  };

  if (isLoading || isSubmitting) {
    return <Loader isLoading />;
  }

  if (isError || !data.id) {
    return <Redirect to="/404" />;
  }

  const survey = new Model(data.schema);
  survey.applyTheme(Theme);
  survey.onComplete.add(onSubmit);

  return (
    <>
      <Header
        isDraft={isDraft}
        isEditing={isEditing}
        title="Request to publish"
        isLoading={headerIsLoading}
        lastUpdated={lastUpdated}
        onBack={handleBack}
        onMenuClick={navigateToEventSettings}
      />
      <FadeIn>
        <div className="pt-[50px] md:pt-[120px] -mt-[90px] pb-20">
          <Survey model={survey} />
        </div>
      </FadeIn>
    </>
  );
};

export default RequestToPublishForm;
